import {AvoirFournisseurLigneDto} from "./avoir-fournisseur-ligne-dto";
import {PrixDto} from "../../prix-dto";
import {FactureFournisseurDto} from "../factures/facture-fournisseur-dto";

export class AvoirFournisseurDto {
  id: number;
  statut: String;
  code: String;
  reference: String;
  facture: FactureFournisseurDto;
  montant: PrixDto;
  montantValide: PrixDto;
  commentaire: String;
  lignes: AvoirFournisseurLigneDto[] = [];

  public static getAllProperties = (): String => {
    return `
      id,
      statut,
      code,
      reference,
      facture {
        ${FactureFournisseurDto.getAllProperties()}
      },
      montant {
        value,
        uniteMonetaire
      },
      montantValide {
        value,
        uniteMonetaire
      },
      commentaire,
      lignes {
        ${AvoirFournisseurLigneDto.getAllProperties()}
      }
    `
  }
}
